import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:4000/api";
const getToken = () => localStorage.getItem("token");

export const getUsers = async ({
  offset = 1,
  limit = 10,
  search = "",
  isActive = "",
  isVerified = "",
} = {}) => {
  return axios.get(`${API_BASE_URL}/admin/users`, {
    params: { offset, limit, search, isActive, isVerified },
    headers: { token: getToken() },
  });
};

export const getUserById = async (id) => {
  return axios.get(`${API_BASE_URL}/admin/users/${id}`, {
    headers: { token: getToken() },
  });
};

export const getPrivateFileBlob = async (filename) => {
  return axios.get(`${API_BASE_URL}/upload/private-file/${filename}`, {
    headers: { token: getToken() },
    responseType: "blob",
  });
};

export const deleteUserById = async (id) => {
  return axios.delete(`${API_BASE_URL}/admin/users/${id}`, {
    headers: { token: getToken() },
  });
};

export const getBookingsUserById = async (id) => {
  return axios.get(`${API_BASE_URL}/admin/booking?user=${id}`, {
    headers: { token: getToken() },
  });
};

export const getSingleBookingById = async (id) => {
  return axios.get(`${API_BASE_URL}/admin/booking/${id}`, {
    headers: { token: getToken() },
  });
};

export const getAllUserBooking = async ({
  offset = 1,
  limit = 10,
  sort,
  isPartner,
  partnerId,
  status = "",
  logisticsType = "",
  fromDate = "",
  toDate = "",
} = {}) => {
  return axios.get(`${API_BASE_URL}/admin/booking`, {
    params: {
      offset,
      limit,
      ...(sort && { sort }),
      ...(isPartner && { isPartner }),
      ...(partnerId && { partnerId }),
      ...(status && { status }),
      ...(logisticsType && { logisticsType }),
      ...(fromDate && { fromDate }),
      ...(toDate && { toDate }),
    },
    headers: {
      token: getToken(),
    },
  });
};
export const uploadSingleFile = async (payload) => {
  return axios
    .post(`${API_BASE_URL}/upload/uploadbase4`, payload)
    .then((response) => {
      return response;
    });
};

export const uploadTransitSingleFile = (data) => {
  return axios.post(`${API_BASE_URL}/upload/transit-file`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getPartners = async () => {
  return axios.get(`${API_BASE_URL}/admin/partners`, {
    headers: { token: getToken() },
  });
};

export const getAdminProfile = async () => {
  return axios.get(`${API_BASE_URL}/admin/profile`, {
    headers: { token: getToken() },
  });
};

export const updateAdminProfile = async (data) => {
  return axios.put(`${API_BASE_URL}/admin/profile`, data, {
    headers: {
      token: getToken(),
    },
  });
};
export const getUsersSubscribers = async ({
  offset = 1,
  limit = 10,
  search = "",
} = {}) => {
  return axios.get(`${API_BASE_URL}/admin/subscriber`, {
    params: { offset, limit, search },
    headers: { token: getToken() },
  });
};

export const updateOrderTotal = (payload) => {
  return axios.post(`${API_BASE_URL}/admin/order/update-total`, payload, {
    headers: { token: getToken() },
  });
};

export const generatePaymentRequest = async (id, payload) => {
  return axios.post(
    `${API_BASE_URL}/admin/order/generate-payment-request`,
    payload,
    {
      headers: { token: getToken() },
    },
  );
};

export const assignBookingToPartner = async (bookingId, partnerId) => {
  return axios.put(
    `${API_BASE_URL}/admin/booking/${bookingId}/${partnerId}`,
    {},
    {
      headers: {
        token: getToken(),
      },
    },
  );
};

export const deleteOrderHistory = async (bookingId, status) => {
  return axios.delete(
    `${API_BASE_URL}/admin/booking/${bookingId}/delete-order-history/${encodeURIComponent(status)}`,
    {
      headers: {
        token: getToken(),
      },
    },
  );
};

export const paymentCallback = async (data) => {
  return axios.post(`${API_BASE_URL}/order/callback`, data, {
    headers: {
      token: getToken(),
      "Content-Type": "application/json",
    },
  });
};
export const updateBookingRequestStatus = async (id, acceptValue) => {
  return axios.put(
    `${API_BASE_URL}/admin/booking/request/update/${id}`,
    {
      accept: acceptValue,
    },
    {
      headers: {
        token: getToken(),
      },
    },
  );
};

export const updatePartnerQuotationStatus = async (
  orderId,
  quotationId,
  status,
  reason = "",
) => {
  return axios.put(
    `${API_BASE_URL}/admin/booking/partner-quotation/update/${orderId}`,
    {
      quotationId,
      status,
      reason,
    },
    {
      headers: {
        token: getToken(),
      },
    },
  );
};

export const updateOrderQuotationDecision = async (payload) => {
  return axios.put(`${API_BASE_URL}/order/quotation`, payload, {
    headers: {
      token: getToken(),
    },
  });
};
export const registerAdmin = async (payload) => {
  return axios.post(`${API_BASE_URL}/admin/register-admin`, payload, {
    headers: {
      token: getToken(),
      "Content-Type": "application/json",
    },
  });
};
export const getAdmins = async ({
  offset = 1,
  limit = 10,
  search = "",
} = {}) => {
  return axios.get(`${API_BASE_URL}/admin/admins`, {
    params: {
      offset,
      limit,
      ...(search.trim() && {
        search: search.trim(),
      }),
    },
    headers: {
      token: getToken(),
    },
  });
};
